export default __webpack_public_path__ + "static/media/futureDeviceIcon.d8ae418e.png";